import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CurrencySymbolSpacePipe } from '../../Pipes/currency-symbol-space.pipe';
import { CheckboxServicesListComponent } from '../../Shared/Components/checkbox-services-list/checkbox-services-list.component';
import { DealerAddressComponent } from '../../Shared/Components/dealer-address/dealer-address.component';
import { FooterSiteInfoComponent } from '../../Shared/Components/footer-site-info/footer-site-info.component';
import { FooterComponent } from '../../Shared/Components/footer/footer.component';
import { HeaderComponent } from '../../Shared/Components/header/header.component';
import { LanguageDropDownComponent } from '../../Shared/Components/language-drop-down/language-drop-down.component';
import { MainHeaderComponent } from '../../Shared/Components/main-header/main-header.component';
import { PageNotFoundComponent } from '../../Shared/Components/page-not-found/page-not-found.component';
import { ServiceListComponent } from '../../Shared/Components/service-list/service-list.component';
import { StepProgressBarComponent } from '../../Shared/Components/step-progress-bar/step-progress-bar.component';
import { SubHeaderComponent } from '../../Shared/Components/sub-header/sub-header.component';
import { UnauthorizePageComponent } from '../../Shared/Components/unauthorize-page/unauthorize-page.component';
import { BrandImageComponent } from './../../Shared/Components/brand-image/brand-image.component';
import { CookiePolicyComponent } from './../../Shared/Components/cookie-policy/cookie-policy.component';
import { MapComponent } from './../../Shared/Components/map/map.component';
import { StepRoutingModule } from './step-routing.module';
import { StepComponent } from './step.component';
import { AfDirectiveModule } from 'projects/Autofacets-Core/src/app/directives/af-directive-core.module';
import { StartComponent } from './Container/start/start.component';
import { FirstStepComponent } from './Container/first-step/first-step.component';
import { SecondStepComponent } from './Container/second-step/second-step.component';
import { ThirdStepComponent } from './Container/third-step/third-step.component';
import { FourthStepComponent } from './Container/fourth-step/fourth-step.component';
import { FifthStepComponent } from './Container/fifth-step/fifth-step.component';
import { SixStepComponent } from './Container/six-step/six-step.component';
import { SevenStepComponent } from './Container/seven-step/seven-step.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';

@NgModule({
  declarations: [
    StepComponent,
    MainHeaderComponent,
    FooterSiteInfoComponent,
    PageNotFoundComponent,
    UnauthorizePageComponent,
    SubHeaderComponent,
    HeaderComponent,
    FooterComponent,
    StartComponent,
    FirstStepComponent,
    SecondStepComponent,
    ThirdStepComponent,
    FourthStepComponent,
    FifthStepComponent,
    SixStepComponent,
    SevenStepComponent,
    ServiceListComponent,
    CheckboxServicesListComponent,
    MapComponent,
    StepProgressBarComponent,
    BrandImageComponent,
    DealerAddressComponent,
    LanguageDropDownComponent,
    CookiePolicyComponent,
    CurrencySymbolSpacePipe
  
  ],
  imports: [ 
    NgbModule,
    CommonModule,
    StepRoutingModule,
    GoogleMapsModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
    NgxIntlTelInputModule,
    AfDirectiveModule
  ],
  schemas: [],
  providers: [],
  bootstrap: []
})
export class StepModule { }
